import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import * as qs from "app/lib/helperjs";
import {Overlay} from "wordpress/themes/easysend/js/ui/overlay";
import {Translate} from "app/services/translate";
import {filter} from 'lodash';
import {SelectSearch} from "./search/search";

const BREAKPOINT_MOBILE = 599;
const MAX_SELECT_HEIGHT = 600;
const MAX_SCROLL_DEVIATION = 350;
const OPTIONS_INSIDE_WRAPPER_CLASS = 'select-inside-options-wrapper';

export class SelectOptionsController {
    constructor(id, value, options, onSelect, onDestroy) {
        this.id = id;
        this.value = value;
        this.options = options;
        this.onSelect = onSelect;
        this.onDestroy = onDestroy;
    }

    init() {
        this.selectScrollYPosition = window.pageYOffset;
        const suggested = filter(this.options, (o) => o.props.suggested);
        const rest = suggested ? filter(this.options, (o) => !o.props.suggested) : this.options;
        const suggestedOptions = this._createOptionsTemplate(suggested);
        const options = this._createOptionsTemplate(rest);

        const selectOptions = (
            <Fragment>
                <div className="select-event-overlay" data-select-overlay={this.id}/>
                <div data-select-options={this.id} className="select-options-wrapper">
                    <SelectSearch placeholder={Translate('common_search')} onSearch={this.handleSearch.bind(this)}/>
                    <div className={OPTIONS_INSIDE_WRAPPER_CLASS}>
                        {suggestedOptions &&
                            <Fragment>
                                <span className="select-options-label">{Translate('commons_suggestions')}</span>
                                {suggestedOptions}
                                <div className="select-divider"/>
                            </Fragment>
                        }
                        {options}
                    </div>
                </div>
            </Fragment>
        );

        ReactDOM.render(selectOptions, Overlay.getDOM, () => {
            Overlay.toggle();
            this._setPosition();
            this._setDimensions();
            this._setVisible(true);

            const eventOverlay = SelectOptionsController.identifySelectEventOverlayDOM(this.id);

            window.addEventListener('scroll', this._revealScrolling.bind(this));
            window.addEventListener('resize', this._setPosition.bind(this));
            eventOverlay && eventOverlay.addEventListener('click', this.destroy.bind(this));
        });
    }

    destroy() {
        const selectOptionsDOM = SelectOptionsController.identifySelectOptionsDOM(this.id);
        const eventOverlay = SelectOptionsController.identifySelectEventOverlayDOM(this.id);

        if (selectOptionsDOM) {
            ReactDOM.unmountComponentAtNode(Overlay.getDOM);
            Overlay.toggle();
        }

        window.removeEventListener('scroll', this._revealScrolling.bind(this));
        window.removeEventListener('resize', this._setPosition.bind(this));
        eventOverlay && eventOverlay.removeEventListener('click', this.destroy.bind(this));
        this.onDestroy();
    }

    handleSelect(value) {
        this.onSelect(value);
        this.destroy();
    }

    handleSearch(event) {
        const {value} = event.target;
        const selectOptionsDOM = SelectOptionsController.identifySelectOptionsDOM(this.id);
        const viewOptions = selectOptionsDOM.querySelectorAll('.select-option');

        viewOptions.forEach((option) => {
            if (option.textContent.toUpperCase().indexOf(value.toUpperCase()) < 0) {
                option.classList.add('hide');
            } else {
                option.classList.remove('hide');
            }
        });

        if (value) {
            selectOptionsDOM.classList.add('searching');
        } else {
            selectOptionsDOM.classList.remove('searching');
        }
    }

    /** @private */
    _createOptionsTemplate(options) {
        return options.map((option) => {
            const {value} = option.props;
            const selectedClass = value === this.value ? 'selected' : '';

            return value && (
                <div key={value} className={`select-option ${selectedClass}`} onClick={() => this.handleSelect(value)}>
                    {option}
                </div>
            );
        })
    }

    /** @private */
    _setPosition() {
        const target = SelectOptionsController.identifySelectTargetDOM(this.id);
        const selectOptionsDOM = SelectOptionsController.identifySelectOptionsDOM(this.id);
        const targetOffset = target.getBoundingClientRect();
        const documentDimensions = window.document.body.getBoundingClientRect();

        if (!selectOptionsDOM) {
            return;
        }

        if (documentDimensions.width < BREAKPOINT_MOBILE) {
            selectOptionsDOM.style.top = targetOffset.top;
            selectOptionsDOM.style.left = '50%';
            selectOptionsDOM.style.transform = 'translateX(-50%)';
            return;
        }

        selectOptionsDOM.style.top = targetOffset.top;
        selectOptionsDOM.style.left = targetOffset.left;
    }

    /** @private */
    _setDimensions() {
        const target = SelectOptionsController.identifySelectTargetDOM(this.id);
        const selectOptionsDOM = SelectOptionsController.identifySelectOptionsDOM(this.id);
        const selectOptionsOffset = selectOptionsDOM.getBoundingClientRect();
        const optionsInsideWrapper = selectOptionsDOM.querySelector(`.${OPTIONS_INSIDE_WRAPPER_CLASS}`);
        const documentDimensions = window.document.body.getBoundingClientRect();

        if (documentDimensions.width < BREAKPOINT_MOBILE) {
            selectOptionsDOM.style.width = documentDimensions.width - 20;
        } else {
            if (target.offsetWidth < 110) {
                selectOptionsDOM.style.width = target.width()+100;
            }
        }

        const maxHeightWrapper = window.innerHeight - selectOptionsOffset.top - 85;

        if(maxHeightWrapper > 100 && maxHeightWrapper < MAX_SELECT_HEIGHT) {
            optionsInsideWrapper.style.maxHeight = maxHeightWrapper;
        }
    }

    /** @private */
    _revealScrolling() {
        if ((window.pageYOffset > (this.selectScrollYPosition + MAX_SCROLL_DEVIATION)) ||
            window.pageYOffset < (this.selectScrollYPosition - MAX_SCROLL_DEVIATION)) {
            this.destroy();
        }
    }

    /** @private */
    _setVisible(bool) {
        const selectOptionsDOM = SelectOptionsController.identifySelectOptionsDOM(this.id);
        bool ? selectOptionsDOM.classList.add('visible') : selectOptionsDOM.classList.remove('visible');
    }

    static identifySelectTargetDOM(uid) {
        return qs.querySelector(`[data-select-target="${uid}"]`);
    }

    static identifySelectOptionsDOM(uid) {
        return qs.querySelector(`[data-select-options="${uid}"]`);
    }

    static identifySelectEventOverlayDOM(uid) {
        return qs.querySelector(`[data-select-overlay="${uid}"]`);
    }
}
